// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"22":"877c5122","186":"c9d43d35","225":"820a9c84","344":"f2847162","372":"f627450c","377":"3671ddb4","443":"afe40403","573":"0e645877","738":"e005d8f8","841":"e2133293","856":"1085a296","909":"bd616473"}[chunkId] + ".chunk.js";
};